document.addEventListener("DOMContentLoaded", function (): void {
    const navbar = document.querySelector<HTMLElement>(".navbar");
    const toggle = document.querySelector<HTMLButtonElement>(".navbar__toggle");
    const nav = document.querySelector<HTMLElement>(".navbar__nav");

    if (!navbar || !toggle || !nav) {
        return;
    }

    // ! assertions below are required because TypeScript doesn't narrow closure-captured variables
    // even though the null guard above guarantees they are non-null at this point.

    function setExpanded(value: boolean): void {
        toggle!.setAttribute("aria-expanded", value ? "true" : "false");
    }

    function closeNavigation(): void {
        navbar!.classList.remove("navbar--open");
        setExpanded(false);
    }

    toggle.addEventListener("click", function (): void {
        const isOpen = !navbar!.classList.contains("navbar--open");
        navbar!.classList.toggle("navbar--open", isOpen);
        setExpanded(isOpen);
    });

    // Close the mobile menu when the user follows a link (e.g. anchor links on the same page).
    nav.querySelectorAll("a").forEach(function (link: Element): void {
        link.addEventListener("click", function (): void {
            if (navbar!.classList.contains("navbar--open")) {
                closeNavigation();
            }
        });
    });

    document.addEventListener("keydown", function (event: KeyboardEvent): void {
        if (event.key === "Escape" && navbar!.classList.contains("navbar--open")) {
            closeNavigation();
        }
    });

    // Search spinner — the form is absent on small viewports where the navbar collapses,
    // so the null check is intentional rather than defensive.
    const searchForm = document.querySelector<HTMLFormElement>("form.navbar__search-form");
    const searchBox = searchForm?.querySelector<HTMLElement>(".search-field");

    if (searchForm && searchBox) {
        searchForm.addEventListener("submit", function (): void {
            searchBox.classList.add("search-field--loading");
        });

        // Back navigation can restore the page from the back/forward cache with the spinner still on.
        window.addEventListener("pageshow", function (event: PageTransitionEvent): void {
            if (event.persisted) {
                searchBox.classList.remove("search-field--loading");
            }
        });
    }
});
